import {
  GET_SIDEBAR_COUNT,
  GET_SIDEBAR_COUNT_SUCCESS,
  GET_SIDEBAR_COUNT_FAILURE,
  UPDATE_SIDEBAR_COUNT,
  UPDATE_SIDEBAR_COUNT_SUCCESS,
  UPDATE_SIDEBAR_COUNT_FAILURE,
} from "../constants";

export default class SidebarCountAction {
  static getSidebarCount(cb) {
    return {
      type: GET_SIDEBAR_COUNT,
      cb,
    };
  }
  static getSidebarCountSuccess(payload) {
    return {
      type: GET_SIDEBAR_COUNT_SUCCESS,
      payload,
    };
  }
  static getSidebarCountFailure() {
    return {
      type: GET_SIDEBAR_COUNT_FAILURE,
    };
  }
  static updateSidebarCount(payload, cb) {
    return {
      type: UPDATE_SIDEBAR_COUNT,
      payload,
      cb,
    };
  }
  static updateSidebarCountSuccess(payload) {
    return {
      type: UPDATE_SIDEBAR_COUNT_SUCCESS,
      payload,
    };
  }
  static updateSidebarCountFailure() {
    return {
      type: UPDATE_SIDEBAR_COUNT_FAILURE,
    };
  }
}
